import z from 'zod';
import {epochTimestamp} from '../_other';
import {journalSessionTypeSchema} from './JournalSessionType';

export const journalSessionDbSchema = z.object({
  // sessionId: z.string().min(1),
  createdAt: epochTimestamp,
  updatedAt: epochTimestamp,
  tradeCount: z.number().int().nonnegative(),
  type: journalSessionTypeSchema,
  note: z.string().optional(),
});

export interface JournalSessionDb extends z.infer<typeof journalSessionDbSchema> {}
